// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CardColumns_wrapper__5OzEx","title":"CardColumns_title__Y9yK9"};